import { gql } from '@apollo/client';
import { RACE_FIELDS, RUNNER_FIELDS, ANALYSIS_FIELDS } from '../fragments';

export const GET_UPCOMING_RACES = gql`
  ${RACE_FIELDS}
  ${RUNNER_FIELDS}
  ${ANALYSIS_FIELDS}
  
  query GetUpcomingRaces($limit: Int = 2) {
    upcomingRaces(limit: $limit, hasTips: true) {
      ...RaceFields
      meeting {
        meeting_id
        track {
          code
          name
          state
          type
        }
      }
      analysis {
        ...AnalysisFields
      }
      runners {
        ...RunnerFields
      }
    }
  }
`;
